import { css } from '@emotion/css';

export const currencyInputCx = css`
  .MuiInputBase-root {
    .currency-symbol {
      margin-right: 0.5rem;
    }
  }
`;
